import './index.scss';
import { useState } from 'react';
import { Radio, DatePicker, Button } from 'antd';
import { Dayjs } from 'dayjs';

type ApiType = 'match' | 'search';
const { VITE_COREDATA_API_URL } = import.meta.env;

const API_ROUTES: Record<ApiType, string> = {
  match: 'public/v2/people/admin_usage',
  search: 'public/v2/profile_search/admin_usage',
};

const ApiUsagePage = () => {
  const [apiType, setApiType] = useState<ApiType>('match');
  const [month, setMonth] = useState<Dayjs | null>(null);

  const handleDownloadCsv = () => {
    const apiUrl = month
      ? `${API_ROUTES[apiType]}?month_gte=${month.format('YYYY-MM-DD')}`
      : API_ROUTES[apiType];

    const url = `${VITE_COREDATA_API_URL.replace('v0/', '')}${apiUrl}`;
    window.location.href = url;
  };
  return (
    <div className="api-usage-page">
      <div className="api-usage-header">
        <div className="title">API Usage</div>
        <div className="secondary">Download API usage statistics as CSV.</div>
      </div>

      <div className="api-usage-download">
        <div className="api-usage-filter">
          <div className="filter-title">API Type</div>
          <Radio.Group
            value={apiType}
            onChange={(e) => setApiType(e.target.value)}
          >
            <Radio value="match">Match API Usage</Radio>
            <Radio value="search">Search API Usage</Radio>
          </Radio.Group>
        </div>

        <div className="api-usage-filter">
          <div className="filter-title">Month (optional)</div>
          <DatePicker
            value={month}
            onChange={setMonth}
            className="date-picker"
          />
        </div>
      </div>

      <Button type="primary" onClick={handleDownloadCsv}>
        Download CSV
      </Button>
    </div>
  );
};

export default ApiUsagePage;
